import { render, staticRenderFns } from "./PerformanceComplexityPage.vue?vue&type=template&id=2bd1f41e&scoped=true&"
import script from "./PerformanceComplexityPage.vue?vue&type=script&lang=js&"
export * from "./PerformanceComplexityPage.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceComplexityPage.vue?vue&type=style&index=0&id=2bd1f41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1f41e",
  null
  
)

export default component.exports